module.exports = __webpack_public_path__ + "assets/images/skincolor-03.f582b418d65ac99edf605212ed9f040c.svg";